import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ServicesHero() {
  return <section data-section-id="1906" id="services-hero" className="relative bg-secondary text-secondary-foreground border-b border-border/20 py-28 md:py-36 overflow-hidden font-default">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Image Column */}
          <div className="order-1 lg:order-2 lg:col-span-5 relative">
            <div className="relative">
              {/* Decorative Number */}
              <div aria-hidden="true" className="pointer-events-none absolute -bottom-8 -right-4 font-default font-bold leading-none select-none text-secondary-foreground/[0.06] z-0" style={{
              fontSize: "16rem"
            }}>
                24
              </div>

              <div className="relative z-10 border border-border/30 group rounded-lg shadow-lg">
                {/* Corner Accents */}
                <span aria-hidden="true" className="absolute top-2 left-2 w-3.5 h-3.5 border-t border-l border-secondary-foreground group-hover:border-primary transition-colors duration-[250ms] ease-out z-20" />
                <span aria-hidden="true" className="absolute top-2 right-2 w-3.5 h-3.5 border-t border-r border-secondary-foreground group-hover:border-primary transition-colors duration-[250ms] ease-out z-20" />
                <span aria-hidden="true" className="absolute bottom-2 left-2 w-3.5 h-3.5 border-b border-l border-secondary-foreground group-hover:border-primary transition-colors duration-[250ms] ease-out z-20" />
                <span aria-hidden="true" className="absolute bottom-2 right-2 w-3.5 h-3.5 border-b border-r border-secondary-foreground group-hover:border-primary transition-colors duration-[250ms] ease-out z-20" />

                <div className="relative aspect-[4/5] overflow-hidden rounded-lg">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/jurnalis_lapangan_berita.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/jurnalis_lapangan_berita.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/jurnalis_lapangan_berita.png-wvc-sizes" alt="Jurnalis sedang meliput berita di lapangan dengan kamera" loading="lazy" decoding="async" className="w-full h-full object-cover" />
                </div>
              </div>
            </div>
          </div>

          {/* Content Column */}
          <div className="order-2 lg:order-1 lg:col-span-7">
            {/* Tagline */}
            <div className="font-mono text-[12px] font-medium uppercase text-primary mb-6" style={{
            letterSpacing: "0.16em"
          }}>
              § REDAKSI INDEPENDEN — TERPERCAYA
            </div>

            {/* Heading */}
            <h1 className="font-default font-bold text-secondary-foreground" style={{
            fontSize: "clamp(2.5rem, 5.4vw, 4.75rem)",
            lineHeight: 1.02,
            letterSpacing: "-0.022em"
          }}>
              Suara <em className="italic font-serif">Kebenaran</em> di Garis Depan.
            </h1>

            {/* Divider */}
            <div className="mt-8 mb-8 flex items-center" aria-hidden="true">
              <div className="h-px bg-border/30" style={{
              width: "220px"
            }} />
              <span className="ml-0 w-1.5 h-1.5 rounded-lg bg-primary inline-block" />
            </div>

            {/* Description */}
            <p className="font-default font-normal text-secondary-foreground/80 max-w-[540px]" style={{
            fontSize: "18px",
            lineHeight: 1.55
          }}>
              Dapatkan akses eksklusif ke investigasi mendalam, laporan klarifikasi terkini, dan opini tajam dari redaksi kami. Kami berkomitmen menyajikan fakta tanpa kompromi untuk masyarakat.
            </p>

            {/* Actions */}
            <div className="mt-10 flex flex-col sm:flex-row gap-4 sm:items-center">
              <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-7 py-3.5 h-auto font-mono uppercase font-medium text-[12px] transition-colors duration-200 ease-out shadow-md" style={{
              letterSpacing: "0.12em"
            }}>
                <Link to="/NewsPage">Baca Berita Terbaru</Link>
              </Button>

              <Button asChild variant="outline" className="bg-transparent border border-secondary-foreground text-secondary-foreground hover:bg-secondary-foreground hover:text-secondary rounded-md px-7 py-3.5 h-auto font-mono uppercase font-medium text-[12px] transition-colors duration-200 ease-out" style={{
              letterSpacing: "0.12em"
            }}>
                <Link to="/SendNewsPage">Kirim Informasi / Tip</Link>
              </Button>
            </div>

            {/* Footer Note */}
            <p className="mt-8 font-default italic text-secondary-foreground/45" style={{
            fontSize: "13px",
            lineHeight: 1.5
          }}>
              mendukung jurnalisme warga yang berintegritas
            </p>
          </div>
        </div>
      </div>
    </section>;
}